import React from 'react';
import './index.less';

interface IProgressBarProps {
	progress: number;
}

export class ProgressBar extends React.Component<IProgressBarProps> {
	render() {
		const progress = Math.max(Math.min(this.props.progress, 100), 0);
		return (
			<div className="progressBar">
				<div style={{ width: progress + '%' }} />
			</div>
		);
	}
}
